

import Dashboard from "carrental/tenant/Dashboard.js"; // version 0.2
//import Dashboard from "carrental/tenant/Mylistings.js";
import Login from "views/pages/Login.js";
import Createv from "carrental/tenant/CreateV.js";
import Mylistings from "carrental/tenant/Mylistings.js";
import Disclaimer from "carrental/tenant/Disclaimer";
import Tenant from "carrental/views/pages/Tenant";
import Adminreq from "carrental/tenant/Adminreq";
import Logs from "carrental/tenant/Logs";

const routestenant = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-bank",
    component: Dashboard,
    layout: "/tenant",
  },
  {
    collapse: true,
    name: "My Tasks",
    icon: "nc-icon nc-book-bookmark",
    state: "tenantpanel",
    views: [
      {
        path: "/profile",
        name: "My Profile",
        mini: "MPF",
        component: Tenant,
        layout: "/tenant",
      },
      {
        path: "/createveh",
        name: "Create Listing",
        mini: "CV",
        component: Createv,
        layout: "/tenant",
      },
      {
        path: "/mylisting",
        name: "My Listing",
        mini: "MLT",
        component: Mylistings,
        layout: "/tenant",
      },
      {
        path: "/myterms",
        name: "Disclaimer Notes",
        mini: "MDC",
        component: Disclaimer,
        layout: "/tenant",
      },
      {
        path: "/myrequests",
        name: "Admin Requests",
        mini: "MAR",
        component: Adminreq,
        layout: "/tenant",
      },
    ],
  },
 
 
  {
    path: "/login",
    component: Login,
    layout: "/auth",
  },
  {
    path: "/getlogs",
    component: Logs,
    layout: "/tenant",
  }
];

export default routestenant;
